window.SuccessStoriesSlider = (randomId) => {
    return {
        swiper: null,
        mq: null,
        init() {
            this.mq = window.matchMedia("(min-width: 1024px)");
            setTimeout(() => {
                this.swiper = new Swiper("#swiper-" + randomId, {
                    slidesPerView: 1,
                    loop: true,
                    grabCursor: true,
                    spaceBetween: 0,
                    a11y: true,
                    autoHeight: !this.mq.matches,
                    pagination: {
                        el: ".swiper-pagination-" + randomId,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<button class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"><span class="dot"></span></button>';
                        },
                    },
                });

                this.mq.addEventListener("change", (e) => {
                    if (!this.swiper) return;
                    this.swiper.params.autoHeight = !e.matches;
                    if (this.swiper.wrapperEl) {
                        this.swiper.wrapperEl.style.height = "";
                    }
                    this.swiper.update();
                    if (!e.matches) {
                        this.swiper.updateAutoHeight();
                    }
                });
            }, 0);
        },
    };
};
